import { HomeSiloOutlineIcon } from './HomeSiloOutlineIcon';

/**
 * author: Jeff Anders
 * id 8943314B-A992-48BD-B030-700F2190B781
 * name home-silo-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-silo-outline.svg
 * tags
 * - Agriculture 
 * - Home Automation 
 */
export const FarmHomeOutlineIcon = HomeSiloOutlineIcon;
export default FarmHomeOutlineIcon